import { Translation } from '../types';

export const da: Translation = {
  common: {
    loading: 'Indlæser...',
    error: 'Fejl',
    cancel: 'Annuller',
    save: 'Gem',
    close: 'Luk',
    search: 'Søg',
    reload: 'Genindlæs',
    logout: 'Log ud',
    dashboard: 'Kontrolpanel',
    products: 'Produkter',
    settings: 'Indstillinger',
    language: 'Sprog',
    businessHours: 'Åbningstider',
    back: 'Tilbage',
    selectAll: 'Vælg alle',
    deselectAll: 'Fravælg alle',
    success: 'Succes',
    selected: 'Valgt',
    confirm: 'Bekræft',
    required: 'Påkrævet',
    requiredMarker: '*',
    previous: 'Forrige',
    next: 'Næste',
    allRightsReserved: 'Alle rettigheder forbeholdes.',
  },
  auth: {
    login: 'Log ind',
    email: 'E-mailadresse',
    password: 'Adgangskode',
    loginButton: 'Log ind',
    loggingIn: 'Logger ind...',
    loginSuccess: 'Login vellykket',
    loginError: 'Forkert e-mail eller adgangskode',
    invalidEmail: 'Indtast venligst en gyldig e-mailadresse',
    requiredFields: 'Udfyld venligst alle påkrævede felter',
    demoAccount: 'Demokonto:',
    loginDescription: 'Indtast dine kontooplysninger for at logge ind',
    welcomeMessage: 'Velkommen til erhvervsbestillingssystemet',
    // Registration
    register: 'Registrer',
    createAccount: 'Opret konto',
    confirmPassword: 'Bekræft adgangskode',
    passwordRequirements: 'Adgangskoden skal være mindst 8 tegn med store og små bogstaver, tal og specialtegn',
    passwordsDoNotMatch: 'Adgangskoderne stemmer ikke overens',
    registrationSuccess: 'Registrering var vellykket',
    registrationDescription: 'Registrer en erhvervskonto',
    alreadyHaveAccount: 'Har du allerede en konto?',
    signIn: 'Log ind',
    dontHaveAccount: 'Har du ikke en konto?',
    creatingAccount: 'Opretter konto...',
    registrationNote: 'Bemærk:',
    registrationNotePoints: {
      erpLinking: 'Hvis du har en eksisterende erhvervskonto, vil din e-mail automatisk blive knyttet',
      companyEmail: 'Brug venligst din virksomheds e-mailadresse til registrering',
      contactSupport: 'Kontakt support, hvis du har brug for hjælp til registreringen'
    },
    b2bUsers: 'Erhvervskontobrugere:',
    registeredEmail: 'Registreret e-mailadresse',
    registeredPassword: 'Adgangskode angivet under registrering',
    b2bCustomerRequired: 'Denne e-mailadresse er ikke registreret som erhvervskunde. Kontakt venligst salgsafdelingen for at etablere et forretningsforhold først.',
    b2bVerificationError: 'Kunne ikke verificere erhvervskundestatus. Kontakt venligst support.',
    // Password Reset
    passwordReset: 'Nulstil adgangskode',
    passwordResetDescription: 'Indtast din e-mailadresse for at få en midlertidig adgangskode',
    getTemporaryPassword: 'Få midlertidig adgangskode',
    processing: 'Behandler...',
    passwordResetComplete: 'Nulstilling af adgangskode fuldført',
    temporaryPasswordGenerated: 'Midlertidig adgangskode er genereret',
    temporaryPassword: 'Midlertidig adgangskode',
    backToLogin: 'Tilbage til login',
    securityNotice: 'Sikkerhedsmeddelelse:',
    securityNotePoints: {
      keepSecret: 'Del ikke den midlertidige adgangskode med andre',
      changeAfterLogin: 'Sørg for at ændre din adgangskode efter login',
      expires24Hours: 'Den midlertidige adgangskode udløber efter 24 timer'
    },
    resetNote: 'Bemærk:',
    resetNotePoints: {
      registeredEmail: 'Indtast din registrerede e-mailadresse',
      passwordDisplayed: 'Den midlertidige adgangskode vil blive vist på skærmen',
      changeRequired: 'Ændring af adgangskode er påkrævet efter login'
    },
    copied: 'Kopieret',
    copySuccessMessage: 'Midlertidig adgangskode kopieret til udklipsholder.',
    forgotPassword: 'Glemt adgangskode?',
    // Password Reset Email Request
    sendResetLink: 'Send nulstillingslink',
    sendingEmail: 'Sender e-mail...',
    emailSent: 'E-mail sendt',
    emailSentMessage: 'Hvis denne e-mailadresse findes i vores system, vil du snart modtage et nulstillingslink.',
    emailNotSent: 'E-mail ikke sendt',
    emailSentInfo: 'Tjek din indbakke og spam-mappe',
    checkEmail: 'Tjek e-mail',
    emailInstructions: 'Instruktioner til nulstilling af adgangskode er blevet sendt',
    nextSteps: 'Næste trin:',
    nextStepsList: {
      checkInbox: 'Tjek din indbakke og spam-mappe',
      clickLink: 'Klik på nulstillingslinket i e-mailen',
      linkExpires: 'Linket udløber om 24 timer',
      contactSupport: 'Kontakt support, hvis du ikke modtager e-mailen',
      rateLimitInfo: 'Begrænset til 3 forespørgsler pr. time'
    },
    // Password Reset Completion
    resetLinkSent: 'Nulstillingslink sendt',
    resetSuccess: 'Adgangskoden blev nulstillet',
    passwordUpdated: 'Adgangskode opdateret',
    passwordUpdateMessage: 'Din adgangskode er blevet opdateret. Du kan nu logge ind med din nye adgangskode.',
    loginWithNewPassword: 'Log ind med ny adgangskode',
    // Reset Token Page
    resetToken: 'Nulstil adgangskode',
    invalidToken: 'Ugyldig nulstillingskode',
    expiredToken: 'Nulstillingskoden er udløbet',
    tokenValid: 'Nulstillingskoden er gyldig',
    newPassword: 'Ny adgangskode',
    confirmNewPassword: 'Bekræft ny adgangskode',
    updatePassword: 'Opdater adgangskode',
    updatingPassword: 'Opdaterer adgangskode...',
    passwordMismatch: 'Adgangskoderne stemmer ikke overens',
    resetInstructions: 'Indtast din nye adgangskode for at fuldføre nulstillingen',
  },
  accountInfo: {
    title: 'Kontooplysninger',
    loading: 'Indlæser kontooplysninger...',
    error: 'Fejl',
    errorMessage: 'Kunne ikke hente kontooplysninger',
    back: 'Tilbage',
    basicInfo: 'Grundlæggende oplysninger',
    name: 'Navn',
    email: 'E-mailadresse',
    contactId: 'Knitido kunde-ID',
    contactNumber: 'Kontaktnummer',
    noInfo: 'Ingen information',
    companyInfo: 'Virksomhedsoplysninger',
    company: 'Virksomhedsnavn',
    position: 'Stilling',
    vatId: 'Momsnummer',
    billingAddress: 'Faktureringsadresse',
    deliveryAddress: 'Leveringsadresse',
    addressInfo: 'Adresseoplysninger',
    billingDescription: 'Adresse til fakturaer og kontraktdokumenter',
    deliveryDescription: 'Standard leveringsadresse for produktforsendelser',
    sameAsBilling: '※ Samme som faktureringsadresse',
    sameAsDelivery: '※ Samme som leveringsadresse',
    companyName: 'Virksomhedsnavn',
    contactPerson: 'Kontaktperson',
    address: 'Adresse',
    phoneNumber: 'Telefonnummer',
    billingUsage: 'Bruges til fakturaer, kontrakter og andre vigtige dokumenter',
    deliveryUsage: 'Bruges som standard leveringsadresse for bestilte produkter',
    alsoUsedForDelivery: 'Bruges også som leveringsdestination',
    accountType: 'Kontotype',
    addressId: 'Adresse-ID',
    // Address editing functionality
    edit: 'Rediger',
    editDeliveryAddress: 'Rediger leveringsadresse',
    editDeliveryDescription: 'Opdater dine leveringsadresseoplysninger',
    newDeliveryAddress: 'Tilføj ny leveringsadresse',
    newDeliveryDescription: 'Indtast detaljerne for din nye leveringsadresse',
    noDeliveryAddress: 'Ingen leveringsadresse konfigureret',
    success: 'Succes',
    addressUpdated: 'Leveringsadressen blev opdateret',
    updateError: 'Kunne ikke opdatere leveringsadressen',
    requiredFields: 'Udfyld venligst alle påkrævede felter',
    firstName: 'Fornavn',
    lastName: 'Efternavn',
    streetAddress: 'Gadeadresse',
    streetAddress2: 'Gadeadresse 2',
    city: 'By',
    country: 'Land',
    selectCountry: 'Vælg land...',
    searchCountry: 'Søg efter land...',
    noCountryFound: 'Intet land fundet.',
    postalCode: 'Postnummer',
    companyNamePlaceholder: 'Indtast virksomhedsnavn',
    firstNamePlaceholder: 'Fornavn',
    lastNamePlaceholder: 'Efternavn',
    streetAddressPlaceholder: 'Indtast gadeadresse',
    streetAddress2Placeholder: 'Lejlighed, suite, osv.',
    cityPlaceholder: 'Indtast by',
    postalCodePlaceholder: 'Indtast postnummer',
    billingNotEditable: 'Faktureringsadresse kan ikke redigeres.',
    billingContactSupport: 'Kontakt support for ændringer.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} leveringsadresser',
    noDeliveryAddresses: 'Ingen leveringsadresser registreret',
    defaultAddress: 'Standard',
    selectDeliveryAddress: 'Vælg leveringsadresse',
    addNewAddress: 'Tilføj ny adresse',
    editAddress: 'Rediger adresse',
    deleteAddress: 'Slet adresse',
    confirmDelete: 'Bekræft sletning',
    confirmDeleteMessage: 'Er du sikker på, at du vil slette denne adresse? Denne handling kan ikke fortrydes.',
    addressAddedSuccess: 'Leveringsadresse tilføjet',
    addressDeletedSuccess: 'Leveringsadresse slettet',
    deleteError: 'Kunne ikke slette leveringsadresse',
    saving: 'Gemmer...',
    cancel: 'Annuller',
    saveChanges: 'Gem ændringer',
    selectedDeliveryAddress: 'Valgt leveringsadresse',
  },
  dashboard: {
    title: 'Forretningspartner',
    subtitle: 'Produktbestillingssystem',
    welcome: 'Velkommen,',
    welcomeMessage: 'Velkommen til forretningspartnerens bestillingssystem. Du kan bestille produkter her.',
    productCatalog: 'Produktkatalog',
    productCatalogDesc: 'Gennemse og bestil tilgængelige produkter',
    viewProducts: 'Vis produkter',
    orderHistory: 'Ordrehistorik',
    orderHistoryDesc: 'Se tidligere bestillinger',
    accountSettings: 'Kontoindstillinger',
    accountSettingsDesc: 'Administrer kontooplysninger',
    comingSoon: 'Kommer snart',
    infoTitle: 'Om brug',
    orderingInfo: 'Produktbestilling',
    orderingDesc: 'Vælg produkter fra kataloget og angiv størrelse og farve. Lagerinformation er tilgængelig i realtid.',
    supportInfo: 'Support',
    supportDesc: 'Kontakt os, hvis du har spørgsmål.',
    viewOrderHistory: 'Vis ordrehistorik',
    viewOrders: 'Vis bestillinger',
    accountInfo: 'Kontooplysninger',
    accountInfoDesc: 'Se kontodetaljer',
    viewDetails: 'Vis detaljer',
    supportEmail: 'b2b-partner@knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Mandag-fredag 9:00 - 15:00 CET',
    bulkImportDesc: 'Importer bestillinger fra Excel/CSV-filer',
    importOrders: 'Importer bestillinger',
  },
  products: {
    title: 'Produktliste',
    subtitle: 'Forretningspartner',
    searchPlaceholder: 'Søg efter produktnavn eller SKU...',
    productId: 'Produkt-ID',
    addToCart: 'Læg i indkøbskurv',
    selectVariation: 'Vælg variant',
    price: 'Pris',
    priceNetNotice: 'Alle priser er ekskl. moms',
    stock: 'Lager',
    color: 'Farve',
    newProducts: 'Nye produkter',
    newProductBadge: 'NY',
    size: 'Størrelse',
    quantity: 'Antal',
    total: 'I alt',
    cart: 'Indkøbskurv',
    checkout: 'Gå til kassen',
    csvMode: 'CSV hurtig-tilstand',
    csvInfo: 'Produktdata hentet fra CSV-data',
    csvUploadDate: 'CSV-uploaddato:',
    stockNote: '※ Lagerinformation hentes, når produktvarianter vælges',
    noProducts: 'Ingen produkter fundet',
    noProductsDesc: 'Ændr søgekriterier eller upload en CSV-fil for hurtigere ydeevne.',
    retry: 'Prøv igen',
    pagination: 'elementer',
    variations: 'varianter',
    stockFetchError: 'Lagerhentningsfejl',
    stockFetchFailed: 'Lagerhentning mislykkedes',
    stockFetchFailedDesc: 'Kunne ikke hente lagerinformation. CSV-lager vil blive vist.',
    stockFetched: 'Lagerinformation hentet',
    totalStock: 'Totalt lager',
    noStockAll: 'Alle varianter er udsolgt',
    noStockData: 'Ingen lagerdata returneret',
    stockFetchErrorDesc: 'Fejl opstod under hentning af lagerinformation',
    selectionError: 'Valgfejl',
    enterQuantity: 'Indtast venligst antal',
    addedToCart: 'Lagt i indkøbskurven',
    typesAdded: ' produkttyper tilføjet',
    addToCartError: 'Fejl ved tilføjelse til indkøbskurv',
    addToCartErrorDesc: 'Prøv venligst igen',
    loadingStock: 'Indlæser lagerinformation',
    csvDataInfo: 'Viser CSV-datainformation (ikke faktiske lagerniveauer)',
    invalidDataFormat: 'Produktdataformatet er ugyldigt',
    loadFailed: 'Kunne ikke indlæse produktdata',
    csvUploadComplete: 'CSV-upload fuldført',
    csvLoadedDesc: ' produktdata indlæst. Lagerinformation vil blive hentet, når du vælger produkter.',
    searchTitle: 'Produktsøgning',
    loadingProducts: 'Indlæser produktdata',
    noProductsCsv: 'Ingen produkter fundet i CSV-data. Ændr venligst søgekriterier.',
    paginationDisplay: ' vist',
    previous: 'Forrige',
    next: 'Næste',
    selectionSummary: 'Valgoversigt',
    selectedQuantity: 'Valgt mængde',
    items: ' varer',
    viewDetails: 'Vis detaljer',
    productImage: 'Produktbillede',
    correspondingVariations: 'Tilsvarende varianter',
    clickToEnlarge: 'Klik for at forstørre',
    productIdLabel: 'Produkt-ID',
    colorLabel: 'Farve',
    filterByCategory: 'Filtrer efter kategori',
    allProducts: 'Alle produkter',
    applyFilters: 'Anvend filtre',
    clearFilters: 'Ryd filtre',
    filters: 'Filtre',
    clearAll: 'Ryd alt',
  },
  categories: {
    category_21: 'Tåstrømper',
    category_23: 'Ukategoriseret',
    category_24: 'Kropsbeklædning',
    category_29: 'B2B-produkter',
  },
  productDetail: {
    title: 'Produktdetaljer',
    backToProducts: 'Tilbage til produkter',
    productNotFound: 'Produkt ikke fundet',
    productNotFoundDesc: 'Det angivne produkt eksisterer ikke eller er blevet slettet.',
    loading: 'Indlæser produkt...',
    imageLoadError: 'Kunne ikke indlæse billeder',
    noImages: 'Ingen billeder tilgængelige',
    productDescription: 'Produktbeskrivelse',
    colors: 'Farver',
    sizes: 'Størrelser',
    colorCount: 'farver',
    sizeCount: 'størrelser',
    variationCount: 'varianter',
    selectVariation: 'Vælg varianter',
    descriptionLanguageNote: '※ Produktbeskrivelser er kun tilgængelige på engelsk eller tysk',
  },
  colors: {
    schwarz: 'Sort',
    weiß: 'Hvid',
    grau: 'Grå',
    rot: 'Rød',
    blau: 'Blå',
    grün: 'Grøn',
    gelb: 'Gul',
    rosa: 'Rosa',
    lila: 'Lilla',
    braun: 'Brun',
    orange: 'Orange',
    beige: 'Beige',
    navy: 'Marineblå',
    dunkelblau: 'Mørkeblå',
    hellblau: 'Lyseblå',
    dunkelgrau: 'Mørkegrå',
    hellgrau: 'Lysegrå',
    bordeaux: 'Bordeaux',
    türkis: 'Turkis',
    khaki: 'Khaki',
    mint: 'Mynte',
    violett: 'Violet',
    anthrazit: 'Antracit',
    blaugrau: 'Blågrå',
    burgunderrot: 'Bourgogne',
    elfenbein: 'Elfenben',
    karminrot: 'Karminrød',
    neongrün: 'Neongrøn',
    gelbgrün: 'Gulgrøn',
    pistazie: 'Pistacie',
    // English color names (used in Product ID 237, etc.)
    blue: 'Blå',
    ivory: 'Elfenben',
    green: 'Grøn',
    gold: 'Guld',
    red: 'Rød',
  },
  checkout: {
    title: 'Kassen',
    cartReview: 'Ordreoversigt',
    orderSummary: 'Ordresammendrag',
    shippingInfo: 'Leveringsinformation',
    billingInfo: 'Faktureringsinformation',
    orderNotes: 'Ordrenotater',
    orderNotesPlaceholder: 'Særlige forespørgsler eller notater...',
    contactPerson: 'Kontaktperson',
    phoneNumber: 'Telefonnummer',
    email: 'E-mailadresse',
    company: 'Virksomhed',
    address: 'Adresse',
    city: 'By',
    postalCode: 'Postnummer',
    country: 'Land',
    deliveryDate: 'Leveringsdato',
    urgentDelivery: 'Ekspreslevering (3-5 hverdage)',
    standardDelivery: 'Standardlevering (7-10 hverdage)',
    placeOrder: 'Afgiv ordre',
    backToCart: 'Tilbage til produktvalg',
    requiredField: 'Påkrævet felt',
    orderTotal: 'Ordretotal',
    subtotal: 'Delsum',
    priceNetNotice: 'Alle priser er ekskl. moms',
    stockReservationNotice: 'Lagerreservation vil ske efter ordrebekræftelse.',
    stockCheckError: 'Lagertjek-fejl',
    stockCheckErrorDesc: 'Fejl opstod under lagertjek. Prøv venligst igen.',
    shipping: 'Fragt',
    shippingCost: 'Fragtpris',
    tax: 'Moms',
    orderSuccess: 'Bestilling gennemført',
    orderSuccessMessage: 'Din bestilling er sendt. Ordrenummer: {orderNumber}',
    orderNumber: 'Ordrenummer',
    thankYou: 'Tak for din bestilling!',
    orderConfirmation: 'Din bestilling er sendt.',
    orderProcessing: 'Efter gennemgang fra vores team vil vi sende dig en ordrebekræftelse via e-mail.',
    orderProcessingMessage: 'Din bestilling er sendt. Efter gennemgang fra vores team vil vi sende dig en ordrebekræftelse via e-mail.',
    continueShopping: 'Fortsæt indkøb',
    emptyCart: 'Din indkøbskurv er tom',
    emptyCartMessage: 'Tilføj venligst produkter til indkøbskurven for at fortsætte',
    stockWarning: 'Lageradvarsel',
    stockWarningDesc: 'Nogle varer har utilstrækkeligt lager. Juster venligst mængder.',
    stockError: 'Lagerfejl',
    stockErrorDesc: 'Der er varer med utilstrækkeligt lager. Juster venligst mængder.',
    refreshStock: 'Opdater lager',
    stockUpdated: 'Lager opdateret',
    stockUpdatedDesc: 'Lager er blevet opdateret - {changed} varer ændret',
    stockCheckDesc: 'Sammenligningsresultater med beholdning vises',
    stockOk: 'Lager OK',
    stockShortage: 'Lagermangel',
    requestedQty: 'Forespurgt mængde',
    currentStock: 'Nuværende lager',
    stockShortageMsg: 'Utilstrækkeligt lager. Juster venligst mængden.',
    stockIssueWarning: 'Ordre kan ikke bekræftes på grund af lagerproblemer.',
    stockDataMissing: 'Lagerdata hentes. Vent venligst et øjeblik.',
    outOfStock: 'Udsolgt.',
    maxAvailable: 'Maksimum',
    autoRestored: 'Kurv gendannet',
    autoRestoredDesc: 'Varer fra din sidste session er gendannet',
    maxQuantityReached: 'Maksimal lagermængde nået.',
    // ERP Contact Search
    contactSearch: 'Kundekontaktsøgning',
    contactSearchDesc: 'Indtast bestillerens e-mailadresse for at hente kontaktoplysninger',
    emailAddress: 'E-mailadresse',
    searchButton: 'Søg',
    searching: 'Søger',
    contactFound: 'Kontakt fundet',
    contactNotFound: 'Kontakt ikke fundet',
    contactId: 'Knitido kunde-ID',
    companyName: 'Virksomhed',
    contactPersonLabel: 'Kontaktperson',
    addressesFound: 'Adresser fundet',
    addressType: 'Type',
    addressBilling: 'Faktureringsadresse',
    addressDelivery: 'Leveringsadresse',
    vatSourceCompany: 'Virksomhedsinfo',
    vatSourceBilling: 'Faktura',
    vatSourceDelivery: 'Levering',
    addressOther: 'Andet',
    addressDetails: 'Adresse',
    loadingAddresses: 'Indlæser adresseoplysninger...',
    addressRetrieved: 'Adresseoplysninger hentet',
    addressNotFound: 'Adresseoplysninger ikke fundet',
    addressNotFoundDesc: 'Ingen registrerede adresseoplysninger. Indtast venligst manuelt.',
    addressError: 'Adressehentningsfejl',
    addressErrorDesc: 'Kunne ikke hente adresseoplysninger.',
    contactNotConfirmed: 'Kundekontakt ikke bekræftet',
    contactNotConfirmedDesc: 'Indtast venligst en e-mailadresse og søg efter kontakten.',
    searchContact: 'Søg kontakt',
    inputError: 'Indtastningsfejl',
    inputErrorDesc: 'Leveringsinformation er ufuldstændig. Tjek venligst.',
    processing: 'Behandler...',
    erpContactSearch: 'Kundekontaktsøgning',
    contactSearchError: 'E-mailadressen matcher ikke nogen registreret kontakt.',
    // Product Images Toggle
    showProductImages: 'Vis produktbilleder',
    showProductImagesDesc: 'Vis produktbilleder for bedre overblik (kan øge indlæsningstiden)',
    // System Registration Info
    systemRegistrationInfo: 'Dine kundeoplysninger',
    editShippingAddress: 'Rediger leveringsadresse',
    systemRegistrationInfoDesc: 'Dine registrerede virksomhedsoplysninger. Kontakt venligst din repræsentant, hvis du har brug for at opdatere faktureringsadressedetaljer.',
    // Order Summary
    regularPrice: 'Ordinær engrospris',
    offeredPrice: 'Tilbudt pris',
    discount: 'Rabat',
    b2bCustomer: 'B2B-kunde',
    pattern: 'Mønster',
    specialPriceApplied: 'Specialpris anvendt',
    customerClassification: 'Kundeklassificering',
    paymentCondition: 'Betalingsbetingelser',
    invoice: 'Faktura (NETTO 30)',
    prepayment: 'Forudbetaling',
    paymentMethod: 'Betalingsmetode',
    invoicePayment: 'Fakturabetaling',
    estimatedSubtotal: 'Estimeret delsum',
    estimatedTotal: 'Estimeret totalsum',
    orderSummaryDisclaimer: 'Priserne vist her er estimater. Når vi modtager din bestilling, vil vi gennemgå den og sende dig en bindende ordrebekræftelse med endelige priser, fragtomkostninger og afgifter via e-mail.',
    searchError: 'Søgefejl',
    searchErrorDesc: 'En fejl opstod under kontaktsøgning.',
    confirmDeleteItem: 'Fjern vare',
    itemDeleted: 'Vare fjernet',
    confirmDeleteItemDesc: 'Er du sikker på, at du vil fjerne følgende vare fra indkøbskurven?',
    deleteConfirm: 'Fjern',
    contactNotes: 'Kontaktnotater',
    contactNotesDesc: 'Har du spørgsmål eller særlige forespørgsler? Giv os besked (valgfrit)',
    contactNotesLabel: 'Besked',
    contactNotesPlaceholder: 'f.eks.: Produktspørgsmål, særlige krav osv.',
    characters: 'tegn',
    contactIdLabel: 'Knitido kunde-ID',
    companyLabel: 'Virksomhed',
    personLabel: 'Kontaktperson',
    emailLabel: 'E-mail',
    addressTypeLabel: 'Type',
    destinationLabel: 'Destination',
    // Shipping Form
    shippingTitle: 'Leveringsinformation',
    shippingDesc: 'Indtast leveringsadressen for produkterne',
    companyRequired: 'Virksomhed *',
    contactPersonRequired: 'Kontaktperson *',
    emailRequired: 'E-mailadresse *',
    phoneRequired: 'Telefonnummer *',
    addressRequired: 'Adresse 1 *',
    address2: 'Adresse 2 (Bygning/Lokale)',
    postalCodeRequired: 'Postnummer *',
    cityRequired: 'By *',
    countryRequired: 'Land *',
    selectCountry: 'Vælg land',
    shippingMethodRequired: 'Leveringsmetode *',
    selectShippingMethod: 'Vælg leveringsmetode',
    urgentDeliveryOption: 'Ekspreslevering (ekstra omkostninger)',
    deliveryNotes: 'Leveringsnotater',
    deliveryNotesPlaceholder: 'Angiv leveringstidspræferencer eller andre forespørgsler',
    standardShipping: 'Standardfragt (3-5 hverdage)',
    expressShipping: 'Ekspresfragt (1-2 hverdage)',
    overnightShipping: 'Levering natten over',
    germany: 'Tyskland',
    austria: 'Østrig',
    switzerland: 'Schweiz',
    japan: 'Japan',
    shippingAddressLabel: 'Leveringsadresse',
    changeDeliveryAddress: 'Skift leveringsadresse',
    selectDeliveryAddress: 'Vælg leveringsadresse',
    // Shipping Cost Details
    freeShipping: 'Gratis fragt',
    shippingError: 'Fejl',
    shippingZone: 'Fragtzone',
    remainingForFreeShipping: '{amount} tilbage for gratis fragt',
    moreForFreeShipping: 'mere for gratis fragt',
    freeShippingProgress: 'Gratis fragt ved',
    andAboveFreeShipping: 'og derover for gratis fragt',
    freeShippingAchieved: 'Gratis fragt opnået',
    threshold: 'og derover',
    nextShippingTier: 'Næste fragtrabat',
    moreForDiscount: 'mere for',
    shippingSavings: 'fragtbesparelser',
    orderAmountThreshold: 'og derover for',
    specialRegionNotice: 'Speciel fragtzone anvendt',
    defaultShippingApplied: 'Standard fragtpriser anvendt',
    requestedQuantity: 'Forespurgt mængde',
    availableQuantity: 'Tilgængelig mængde',
    orderSubmitError: 'Fejl ved ordreafgivelse',
    orderSubmitErrorDesc: 'Ordren kunne ikke indsendes',
    upload: {
      title: 'Importer Excel/CSV-bestilling',
      description: 'Upload en Excel- eller CSV-fil med dine bestillingsdata',
      dragDropOrClick: 'Træk og slip fil her eller klik for at vælge',
      dropHere: 'Slip fil her',
      supportedFormats: 'Understøttede formater: Excel (.xlsx, .xls) og CSV (.csv)',
      maxSize: 'Maksimal filstørrelse: {size} MB',
      processFile: 'Behandle fil',
      processing: 'Behandler fil...',
      ready: 'Fil klar til forhåndsvisning',
      readyDescription: 'Din fil er blevet behandlet og er klar til gennemgang.',
      preview: 'Vis forhåndsvisning',
      errors: {
        fileTooLarge: 'Filen er for stor. Maksimal størrelse: {size} MB',
        invalidFileType: 'Ugyldig filtype. Upload venligst en Excel- eller CSV-fil',
        uploadFailed: 'Fejl ved upload af fil',
      },
    },
    // Loading messages
    loadingPage: 'Indlæser side...',
    loadingStock: 'Tjekker produktlager...',
    loadingAccount: 'Indlæser kontooplysninger...',
    loadingError: 'Der opstod en fejl...',
    loadingData: 'Indlæser data',
    // Toast messages
    addressRetrievedTitle: 'Adresseoplysninger hentet',
    addressSetAsDelivery: ' adresse sat som leveringsdestination.',
    contactFoundDesc: ' blev genkendt.'
  },
  orderHistory: {
    title: 'Ordrehistorik',
    searchPlaceholder: 'Søg efter ordrenummer eller SKU...',
    noOrders: 'Ingen bestillinger fundet',
    noOrdersFound: 'Ingen matchende bestillinger fundet',
    startShopping: 'Vis produkter',
    orderItems: 'Ordrevarer',
    viewDetails: 'Detaljer',
    reorder: 'Bestil igen',
    orderDate: 'Ordredato',
    orderStatus: 'Status',
    orderTotal: 'Ordretotal',
    // Status translations
    statusPending: 'Afventer betaling',
    statusProcessing: 'Behandler',
    statusConfirmed: 'Bekræftet',
    statusShipped: 'Sendt',
    statusDelivered: 'Leveret',
    statusCancelled: 'Annulleret',
    statusReturned: 'Returneret',
    statusRefunded: 'Refunderet',
    statusWarranty: 'Garanti',
    statusExchanged: 'Byttet',
    statusRepair: 'Reparation',
    statusUnknown: 'Ukendt',
    statusIncomplete: 'Ufuldstændig',
    statusWaitingPayment: 'Afventer betaling',
    statusInPreparation: 'Under forberedelse',
    statusClearedShipping: 'Klar til forsendelse',
    statusBeingShipped: 'Afsendes',
    statusOutgoingBooked: 'Udgående booket',
    statusReturn: 'Retur',
    // Additional UI elements
    itemCount: 'varer',
    itemCountSingular: 'vare',
    refreshButton: 'Opdater',
    errorFetchingOrders: 'Kunne ikke hente ordrehistorik',
    // Payment status features
    paymentStatus: 'Betalingsstatus',
    markAsPaid: 'Marker som betalt',
    unmarkAsPaid: 'Fjern betalingsmarkering',
    paidOn: 'Betalt',
    paymentMarked: 'Betalt',
    notPaid: 'Ikke betalt',
    paymentMarkedSuccess: 'Vellykket markeret som betalt',
    paymentUnmarkedSuccess: 'Betalingsmarkering fjernet',
    paymentUpdateError: 'Kunne ikke opdatere betalingsstatus',
    // Payment date dialog
    paymentDateTitle: 'Indtast betalingsinformation',
    paymentDateDescription: 'Indtast betalingsinformation for ordre {orderNumber}',
    paymentDateLabel: 'Betalingsdato',
    selectDate: 'Vælg dato',
    paymentDateHelp: 'Vælg datoen, hvor bankoverførslen blev foretaget',
    paymentMethodLabel: 'Betalingsmetode',
    bankTransfer: 'Bankoverførsel',
    invoice: 'Faktura',
    otherPayment: 'Andet',
    paymentReferenceLabel: 'Overførselsnavn / Referencenummer',
    paymentReferencePlaceholder: 'f.eks. Jens Jensen, Overførsel #12345',
    paymentReferenceHelp: 'Indtast information, der hjælper med at matche med kontoudtog',
    notesLabel: 'Notater',
    notesPlaceholder: 'Indtast eventuel yderligere information om betalingen',
    // Filter options
    filterByPaymentStatus: 'Filtrer efter betalingsstatus',
    allOrders: 'Alle bestillinger',
    paidOrders: 'Betalte',
    unpaidOrders: 'Ubetalte',
    // Sorting options
    sortBy: 'Sorter efter',
    sortByDate: 'Ordredato',
    sortByPaymentDate: 'Betalingsdato',
    sortByAmount: 'Beløb',
    sortByStatus: 'Status',
  },
  orderDetails: {
    title: 'Ordredetaljer',
    notFound: 'Ordre ikke fundet',
    backToHistory: 'Tilbage til ordrehistorik',
    orderDate: 'Ordredato',
    orderItems: 'Ordrevarer',
    deliveryStatus: 'Leveringsstatus',
    estimatedDelivery: 'Estimeret levering',
    deliveredOn: 'Leveret',
    downloadInvoice: 'Download faktura',
    statusDelivered: 'Leveret',
    statusShipped: 'Sendt',
    statusConfirmed: 'Bekræftet',
    statusCancelled: 'Annulleret',
    errorFetchingDetails: 'Kunne ikke hente ordredetaljer',
  },
  company: {
    name: 'Forretningspartner',
    tagline: 'Forretningspartnersystem',
    copyright: '© 2025 Forretningspartnersystem. Alle rettigheder forbeholdes.',
  },
  footer: {
    phone: 'Telefon',
    email: 'E-mail',
    countries: {
      DE: 'Tyskland',
      AT: 'Østrig',
      CH: 'Schweiz',
      FR: 'Frankrig',
      IT: 'Italien',
      ES: 'Spanien',
      NL: 'Holland',
      BE: 'Belgien',
      PL: 'Polen',
      SE: 'Sverige',
      NO: 'Norge',
      FI: 'Finland',
      DK: 'Danmark',
      LT: 'Litauen',
      LV: 'Letland',
      EE: 'Estland',
    },
  },
  cart: {
    newCart: 'Ny indkøbskurv',
    currentCart: 'Nuværende indkøbskurv',
    modified: 'ændret',
    lastSaved: 'Sidst gemt',
    unsavedChanges: 'ugemte ændringer',
    saveCart: 'Gem indkøbskurv',
    loadCart: 'Indlæs indkøbskurv',
    deleteCart: 'Slet indkøbskurv',
    startNewCart: 'Start ny indkøbskurv',
    savedCarts: 'Gemte indkøbskurve',
    cartSaved: 'Indkøbskurv gemt',
    cartDeleted: 'Indkøbskurv slettet',
    confirmDeleteCart: 'Slet indkøbskurv?\n\nDenne handling kan ikke fortrydes.',
    confirmSwitchCart: 'Den nuværende indkøbskurv har ugemte ændringer.\n\nHvis du indlæser en anden indkøbskurv, mistes de nuværende ændringer.\n\nFortsæt?',
    confirmSwitchCartTitle: 'Skift indkøbskurv',
    confirmNewCart: 'Den nuværende indkøbskurv har ugemte ændringer.\n\nHvis du starter en ny indkøbskurv, mistes de nuværende ændringer.\n\nFortsæt?',
    confirmNewCartTitle: 'Start ny indkøbskurv',
    confirmClearCart: 'Tøm indkøbskurv?\n\n{count} varer vil blive fjernet.\n\nDenne handling kan ikke fortrydes.',
    confirmClearCartTitle: 'Tøm indkøbskurv',
    autoSaved: 'Autogemt',
    itemsWillBeRemoved: 'varer vil blive fjernet',
    changesWillBeLost: 'ændringer vil gå tabt',
    continueQuestion: 'Fortsæt?',
    cartStatus: 'Indkøbskurvstatus',
    cartName: 'Indkøbskurvnavn',
    cartNamePlaceholder: 'f.eks.: Månedsslutbestilling',
    cartNameRequired: 'Indtast venligst et indkøbskurvnavn',
    saveCartDescription: 'Giv den nuværende indkøbskurv et navn og gem den. Du kan indlæse den senere.',
    cancelCart: 'Annuller indkøbskurv',
    proceedToCheckout: 'Gå til kassen',
    emptyCart: 'Indkøbskurven er tom',
    erpDown: 'Bestillingssystemet er nede. Prøv venligst igen senere.',
    erpDegraded: 'Systemet er i øjeblikket ustabilt. Bestillinger kan mislykkes.',
    erpDownSaveHint: 'Gem din indkøbskurv og bestil, når systemet er genoprettet.',
    erpSaveCart: 'Gem kurv',
  },
  nav: {
    dashboard: 'Kontrolpanel',
    products: 'Produkter',
    orderHistory: 'Bestillinger',
    account: 'Kontooplysninger',
    bulkImport: 'Masseimport',
  },
  settings: {
    selectLanguage: 'Vælg et sprog',
    languagePreferenceSaved: 'Dit valg vil blive gemt på din konto til fremtidige besøg.',
  },
  reorder: {
    allItemsAdded: '{count} varer lagt i indkøbskurven',
    partialSuccess: '{added} varer tilføjet. {failed} varer kunne ikke tilføjes',
    allItemsFailed: 'Kunne ikke tilføje varer til indkøbskurven',
    error: 'En fejl opstod under genbestilling',
    itemDiscontinued: '{name} ({color}/{size}) er udgået',
    itemOutOfStock: '{name} ({color}/{size}) er udsolgt',
    partialStock: '{name} ({color}/{size}) kun {available} tilgængelig',
    confirmReorder: 'Bekræft genbestilling',
    confirmReorderMessage: 'Læg varer fra denne bestilling i indkøbskurven?',
    addingToCart: 'Lægger i indkøbskurv...',
    checkingStock: 'Tjekker lager...',
    checkoutTitle: 'Varer lagt i indkøbskurv',
    checkoutDescription: '{count} varer er blevet lagt i din indkøbskurv. Ønsker du at gå til kassen?',
  },
  bulkImport: {
    instructions: 'Sådan importerer du bestillinger',
    step1: 'Download ordreskabelonen',
    step2: 'Udfyld dine bestillingsdata med SKU og mængde',
    step3: 'Gem som Excel (.xlsx) eller CSV-fil',
    step4: 'Upload filen ved hjælp af formularen nedenfor',
    step5: 'Gennemgå og bekræft din bestilling',
    downloadTemplate: 'Download skabelon',
    downloadExcelTemplate: 'Download Excel-skabelon',
    downloadCsvTemplate: 'Download CSV-skabelon',
    formatGuide: 'Filformatvejledning',
    requiredColumns: 'Påkrævede kolonner',
    skuDescription: 'Produkt-SKU-kode',
    quantityDescription: 'Bestillingsmængde (positivt heltal)',
    optionalColumns: 'Valgfrie kolonner',
    notesDescription: 'Interne notater (f.eks. PO-nummer, reference) - kun til dine optegnelser',
    formatNote: 'Første række skal indeholde kolonneoverskrifter. Data starter fra anden række.',
    parseSuccess: 'Vellykket behandlet {count} varer fra filen',
    parseError: 'Behandlingsfejl',
    validationError: 'Valideringsfejl',
    validationErrorGuidance: 'Klik venligst på "{showPreviewButton}"-knappen for at gennemgå detaljerne.',
    warnings: 'Advarsler',
    itemsParsed: 'Vellykket behandlet {count} varer:',
    andMore: '...og {count} flere varer',
    validationSummary: 'Valideringsoversigt',
    duplicateSKUs: 'Duplikerede SKU-er fundet',
    skuFormat: 'SKU må kun indeholde bogstaver, tal og bindestreger',
    quantityRange: 'Mængde skal være mellem 1 og 9999',
    maxRows: 'Maksimalt 1000 rækker tilladt',
    rowsSkipped: '{count} rækker blev sprunget over på grund af fejl',
    previewTitle: 'Ordreforhåndsvisning',
    previewDescription: 'Gennemgå og rediger dine bestillingsdata, før du fortsætter',
    proceedToCart: 'Læg i indkøbskurv',
    // File parsing messages
    fileEmpty: 'Filen er tom eller indeholder ingen data',
    fileTooManyRows: 'Filen indeholder for mange rækker ({current}). Maksimalt tilladt: {max}',
    invalidRowFormat: 'Ugyldigt rækkeformat',
    missingColumns: 'Mangler påkrævede kolonner (SKU og Mængde)',
    missingSku: 'Mangler SKU',
    invalidSkuFormat: 'Ugyldigt SKU-format: "{sku}" (skal matche mønster: {pattern})',
    skuTooLong: 'SKU for lang: "{sku}" (maksimalt 50 tegn)',
    invalidQuantity: 'Ugyldig mængde: "{quantity}" er ikke et tal',
    quantityTooLow: 'Mængde for lav: {quantity} (minimum: {min})',
    quantityTooHigh: 'Mængde for høj: {quantity} (maksimum: {max})',
    notesRequired: 'Notatfelt påkrævet',
    noValidData: 'Ingen gyldige data fundet. Tjek venligst dit filformat.',
    row: 'Række {row}: {errors}',
    rowErrors: '...og {count} flere fejl',
    duplicateSkuInRows: 'Duplikeret SKU "{sku}" fundet i rækker: {rows}',
    quantityExceedsMax: 'Række {row}: Mængde {quantity} overskrider maksimalt tilladt ({max})',
    quantityBelowMin: 'Række {row}: Mængde {quantity} er under minimum påkrævet ({min})',
    // Validation messages
    unsupportedFileFormat: 'Ikke-understøttet filformat. Upload venligst en CSV- eller Excel-fil.',
    csvParsingErrors: 'CSV-behandlingsfejl opstod',
    failedToParseFile: 'Kunne ikke behandle fil',
    failedToParseExcel: 'Kunne ikke behandle Excel-fil',
    failedToReadFile: 'Kunne ikke læse fil',
    unknownError: 'Ukendt fejl opstod',
    totalRows: 'Totalt rækker',
    valid: 'Gyldige',
    invalid: 'Ugyldige',
    skipped: 'Sprunget over',
    // SKU validation
    skuValidationError: 'SKU-valideringsfejl',
    skuValidationFailed: 'Kunne ikke validere SKU-er. Du kan stadig fortsætte, men nogle varer er måske ikke tilgængelige.',
    skuNotFound: 'SKU ikke fundet i databasen',
    skusNotFound: '{count} SKU-er ikke fundet i databasen',
    itemsHaveInsufficientStock: '{count} varer har utilstrækkeligt lager',
    validatingSKUs: 'Validerer varer...',
    unvalidatedChanges: 'Du har uvaliderede ændringer. Valider venligst igen, før du lægger i indkøbskurven.',
    revalidate: 'Valider igen',
    validating: 'Validerer...',
    validationSuccess: 'Alle varer er gyldige',
    validationComplete: 'Validering fuldført',
    validationResultSummary: '{errors} fejl, {warnings} advarsler fundet',
    // Table headers
    actions: 'Handlinger',
    notes: 'Notater',
    // Status filter
    all: 'Alle',
    hasErrors: 'Har fejl',
    // Selection summary
    selected: 'valgt',
    errors: 'fejl',
    // Pagination
    page: 'Side {current} af {total}',
    previous: 'Forrige',
    next: 'Næste',
    noResults: 'Ingen resultater.',
    // Cart integration
    noValidItems: 'Ingen gyldige varer',
    allItemsHaveErrors: 'Alle varer har valideringsfejl. Ret dem venligst, før du fortsætter.',
    dataLoadingError: 'Dataindlæsningsfejl',
    failedToLoadProductData: 'Kunne ikke indlæse produktdata. Prøv venligst igen.',
    itemsAddedToCart: '{count} varer lagt i indkøbskurv',
    itemsAddedMessage: 'Tilføjede {count} varer til indkøbskurven',
    someSkusNotFound: '{count} SKU-er kunne ikke findes.',
    noItemsAdded: 'Ingen varer tilføjet',
    couldNotFindProducts: 'Kunne ikke finde nogen produkter, der matcher SKU-erne.',
    errorAddingToCart: 'Fejl',
    failedToAddToCart: 'Kunne ikke tilføje varer til indkøbskurven. Prøv venligst igen.',
    addingToCart: 'Lægger i indkøbskurv...',
    // File info
    fileSelected: '{name} valgt til behandling',
    fileSize: '{size} bytes',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Skabelon-download',
    templateWillBeImplemented: 'Skabelon-download vil blive implementeret i fase 7',
    // Additional validation
    validationFailed: 'Validering mislykkedes',
    // Template download
    templateDownloaded: 'Skabelon downloadet',
    templateDownloadError: 'Kunne ikke downloade skabelon',
    // Template content
    sheetName: 'Massebestilling',
    instructionsSheetName: 'Instruktioner',
    columnDescriptions: 'Kolonnebeskrivelser:',
    columnHeader: 'Kolonne',
    columnRequired: 'Påkrævet',
    columnOptional: 'Valgfri',
    columnDescription: 'Beskrivelse',
    templateNotes: 'Notater:',
    templateNote1: 'Første række skal indeholde kolonneoverskrifter nøjagtigt som vist',
    templateNote2: 'Data starter fra række 2',
    templateNote3: 'SKU skal matche eksisterende produktkoder i systemet',
    templateNote4: 'Mængde skal være et positivt heltal mellem 1 og 9999',
    templateNote5: 'Maksimalt 1000 rækker tilladt pr. fil',
    templateNote6: 'Gem som .xlsx- eller .csv-format',
    stockAvailabilityWarning: 'Faktisk lagertilgængelighed vil blive tjekket på næste kasseside.',
    outOfStock: 'Udsolgt',
    insufficientStock: 'Utilstrækkeligt lager: {available} tilgængelig, {requested} forespurgt',
  },
  orderExport: {
    export: 'Eksporter bestilling',
    exportOrder: 'Eksporter bestillingsdata',
    exportAsCSV: 'Eksporter som CSV',
    exportAsExcel: 'Eksporter som Excel',
    exportForReorder: 'Eksporter til masseimport',
    detailed: 'Fuldstændige detaljer',
    simpleFormat: 'Importformat',
  },
};
